module.exports = new __parcel__URL__("vishwanath.13ab1960.png").toString();